export default __webpack_public_path__ + "static/animatedIntroThumb-ec13fc999116770acece9afd60ea1068.png";